import { render, staticRenderFns } from "./DialogRoom.vue?vue&type=template&id=66f67801&"
import script from "./DialogRoom.vue?vue&type=script&lang=ts&"
export * from "./DialogRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports